import { injectGlobal } from 'styled-components';

injectGlobal`
  @font-face {
    font-family: 'hui-icons';
    font-style: normal;
    font-weight: normal;
    src: url('https://assets.homeimprovementpages.com.au/fonts/hui-icons.d030f6.ttf') format('truetype'),
         url('https://assets.homeimprovementpages.com.au/fonts/hui-icons.f506cb.woff') format('woff');
  }
  
  [class^="hui-icon-"], [class*=" hui-icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'hui-icons' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
  
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .hui-icon-send-message .path1:before {
    content: "\\e914";
    color: rgb(255, 123, 17);
  }
  .hui-icon-send-message .path2:before {
    content: "\\e915";
    margin-left: -1.125em;
    color: rgb(51, 51, 51);
  }
  .hui-icon-request-recommendation:before {
    content: "\\e916";
    color: #333;
  }
  .hui-icon-report-lead:before {
    content: "\\e917";
    color: #333;
  }
  .hui-icon-overflow:before {
    content: "\\e918";
    color: #333;
  }
  .hui-icon-message2:before {
    content: "\\e919";
    color: #333;
  }
  .hui-icon-mark-as-hired:before {
    content: "\\e91a";
    color: #333;
  }
  .hui-icon-job-title:before {
    content: "\\e91b";
    color: #333;
  }
  .hui-icon-job-location:before {
    content: "\\e91e";
    color: #333;
  }
  .hui-icon-edit:before {
    content: "\\e91f";
    color: #888;
  }
  .hui-icon-collect-payment:before {
    content: "\\e920";
    color: #333;
  }
  .hui-icon-close:before {
    content: "\\e921";
    color: #333;
  }
  .hui-icon-call:before {
    content: "\\e922";
    color: #333;
  }
  .hui-icon-attachment2:before {
    content: "\\e923";
    color: #333;
  }
  .hui-icon-archive:before {
    content: "\\e924";
    color: #333;
  }
  .hui-icon-email:before {
    content: "\\e908";
    color: #333;
  }
  .hui-icon-bank-transfer:before {
    content: "\\e90e";
  }
  .hui-icon-cash:before {
    content: "\\e90d";
  }
  .hui-icon-calendar:before {
    content: "\\e90c";
  }
  .hui-icon-receipt:before {
    content: "\\e90f";
  }
  .hui-icon-modal-close:before {
    content: "\\e910";
  }
  .hui-icon-right-arrow:before {
    content: "\\e911";
  }
  .hui-icon-back:before {
    content: "\\e912";
  }
  .hui-icon-button-tick:before {
    content: "\\e913";
  }
  .hui-icon-cheque:before {
    content: "\\e91d";
  }
  .hui-icon-credit-card:before {
    content: "\\e925";
  }
  .hui-icon-spanner:before {
    content: "\\e906";
  }
  .hui-icon-gallery:before {
    content: "\\e905";
    color: #333;
  }
  .hui-icon-verification:before {
    content: "\\e901";
  }
  .hui-icon-recommendation:before {
    content: "\\e902";
  }
  .hui-icon-lock:before {
    content: "\\e903";
  }
  .hui-icon-payment:before {
    content: "\\e904";
  }
  .hui-icon-tag:before {
    content: "\\e900";
  }
  .hui-icon-attachment:before {
    content: "\\e810";
  }
  .hui-icon-refresh:before {
    content: "\\e811";
  }
  .hui-icon-details-circle:before {
    content: "\\e80a";
  }
  .hui-icon-user-circle:before {
    content: "\\e80b";
  }
  .hui-icon-job:before {
    content: "\\e806";
  }
  .hui-icon-message:before {
    content: "\\e807";
  }
  .hui-icon-hamburger:before {
    content: "\\e808";
  }
  .hui-icon-search:before {
    content: "\\e809";
  }
  .hui-icon-mobile:before {
    content: "\\e805";
  }
  .hui-icon-user:before {
    content: "\\e804";
    color: #333;
  }
  .hui-icon-home:before {
    content: "\\e80c";
  }
  .hui-icon-location:before {
    content: "\\e80d";
  }
  .hui-icon-phone:before {
    content: "\\e80f";
  }
  .hui-icon-subcategory:before {
    content: "\\e80e";
  }
  .hui-icon-star:before {
    content: "\\e90b";
  }
  .hui-icon-bell:before {
    content: "\\e907";
  }
  .hui-icon-free:before {
    content: "\\e909";
  }
  .hui-icon-lightening:before {
    content: "\\e90a";
  }
  .hui-icon-hip-logo:before {
    content: "\\e91c";
  }
  .hui-icon-twitter:before {
    content: "\\f099";
  }
  .hui-icon-facebook:before {
    content: "\\f09a";
  }
  .hui-icon-google-plus:before {
    content: "\\f0d5";
  }
  .hui-icon-linkedin:before {
    content: "\\f0e1";
  }
  .hui-icon-angle-up:before {
    content: "\\f106";
  }
  .hui-icon-angle-down:before {
    content: "\\f107";
  }
  .hui-icon-circle:before {
    content: "\\f111";
  }
  .hui-icon-youtube:before {
    content: "\\f167";
  }
  .hui-icon-instagram:before {
    content: "\\f16d";
  }
  .hui-icon-dribbble:before {
    content: "\\f17d";
  }
  .hui-icon-pinterest-p:before {
    content: "\\f231";
  }
`;
